// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { colors } from "../../../utils/theme/colors"
import Container from "../container"
import { useStaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"
import _content from "../../../content/layouts/footer.json"
import SaaSColumn from "./SaaSColumn"
import ServiceColumn from "./ServicesColumn"
import AboutUsColumn from "./AboutUsColumn"
import AddressUs from "./AddressUs"
import AddressFr from "./AddressFr"
import Button from "../../../components/button"

const Footer = ({ langKey }) => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      SeelkLogo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(width: 194, height: 60, quality: 100) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      SeelkLogoMobile: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          fixed(width: 131, height: 40) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      FRflag: file(relativePath: { eq: "france.png" }) {
        childImageSharp {
          fixed(width: 20, height: 20) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      UKflag: file(relativePath: { eq: "united-kingdom.png" }) {
        childImageSharp {
          fixed(width: 20, height: 20) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
      linkedin: file(relativePath: { eq: "linkedin.png" }) {
        childImageSharp {
          fixed(width: 30, height: 30) {
            ...GatsbyImageSharpFixed_withWebp
          }
        }
      }
    }
  `)
  const { copyrights } = _content[langKey]
  return (
    <div
      sx={{
        backgroundColor: colors.code.secondary,
        py: [`3rem`, null, 0, null],
      }}
    >
      <Container>
        <div
          sx={{
            display: `flex`,
            flexDirection: [`column`, null, `row`, null],
            alignItems: `center`,
            height: [`100%`, null, `34rem`, null],
          }}
        >
          <div
            sx={{
              display: `flex`,
              justifyContent: `space-between`,
              width: `100%`,
              flexDirection: [`column`, null, `row`, `row`],
            }}
          >
            <div
              sx={{
                display: "flex",
                flexDirection: ["column", "column", "row", "row"],
                order: [1, 1, 0, 0],
                justifyContent: "space-between",
                width: ["100%", "100%", "33%", "33%"],
              }}
            >
              <ServiceColumn langKey={langKey} />
              <SaaSColumn langKey={langKey} />
            </div>
            <div
              sx={{
                display: `flex`,
                width: ["100%", "100%", "33%", "33%"],
                flexDirection: `column`,
                order: [0, 0, 1, 1],
                alignItems: [null, null, `center`, null],
                marginTop: [null, null, `-30px`, null],
              }}
            >
              <Img alt="" fixed={data.SeelkLogo.childImageSharp.fixed} />
              <div
                sx={{
                  display: `flex`,
                  width: `55px`,
                  justifyContent: `space-between`,
                  marginTop: `1rem`,
                  marginBottom: `3rem`,
                }}
              >
                <Link
                  sx={{
                    textDecoration: `none`,
                  }}
                  to={`/fr/`}
                >
                  <Img alt="" fixed={data.FRflag.childImageSharp.fixed} />
                </Link>
                <Link
                  sx={{
                    textDecoration: `none`,
                  }}
                  to={"/"}
                >
                  <Img alt="" fixed={data.UKflag.childImageSharp.fixed} />
                </Link>
              </div>

              <div
                sx={{
                  marginBottom: `1.5rem`,
                  display: `flex`,
                  justifyContent: `space-between`,
                }}
              >
                <a
                  href="https://www.linkedin.com/company/seelk/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <Img alt="" fixed={data.linkedin.childImageSharp.fixed} />
                </a>
              </div>

              <div sx={{ width: `55%` }}>
                <p
                  sx={{
                    color: colors.code.footerText,
                    fontSize: `0.94rem`,
                    lineHeight: 2.33,
                    margin: 0,
                    textAlign: [`left`, null, `center`, null],
                  }}
                >
                  {copyrights}
                </p>
              </div>
            </div>

            <div
              sx={{
                display: "flex",
                justifyContent: "space-between",
                width: ["100%", "100%", "33%", "33%"],
                order: [1, 1, 1, 1],
                flexDirection: ["column", "column", "row", "row"],
              }}
            >
              <AboutUsColumn langKey={langKey} />
              <div
                sx={{
                  display: `flex`,
                  flexDirection: `column`,
                }}
              >
                <AddressUs langKey={langKey} />
                <AddressFr langKey={langKey} />
                <Link
                  sx={{
                    textDecoration: `none`,
                  }}
                  to={langKey === "en" ? "/contact" : `/${langKey}/contact`}
                >
                  <Button
                    overrideCSS={{
                      borderRadius: "5px",
                      backgroundColor: "transparent",
                      color: colors.code.primary,
                      border: `2px solid ${colors.code.primary}`,
                      width: `fit-content`,
                      height: `2.7rem`,
                      ":hover": {
                        background: `#F58D00 0% 0% no-repeat`,
                        color: colors.white,
                        cursor: `pointer`,
                      },
                    }}
                  >
                    Contact
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default Footer
